module.exports = __webpack_public_path__ + "static/media/lainie.25dc13e9.ttf";